module.exports = angular.module('cartographer.map.marker', [])

_     = require 'underscore'
Color = require 'color'

module.exports.factory 'crtMarkerColor', $DI (crtLog) ->
  FADE_LEVEL = 0.05 # transparency

  pair = (stroke, fill) ->
    { stroke, fill }

  create = (base) ->
    return {
      fill   : Color(base).lighten(0.1).fade(FADE_LEVEL).string()
      stroke : Color(base).darken(0.4).string()
    }

  _fromFunc = (func) ->
    return {
      fill   : func(true)
      stroke : func(false)
    }

  blank       = pair("rgba(128, 128, 128, 0.5)", "transparent")

  # Cursor in map fields (grey circle):
  fieldCursor = pair("rgb(252, 252, 252)", "rgba(0, 0, 0, 0.2)")

  # Lines in map fields (neutral blue):
  fieldGeom   =
    base     : pair("hsl(200, 100%, 50%)", "hsla(200, 100%, 50%, 10%)")
    selected : pair("hsl(200, 100%, 40%)", "hsla(200, 100%, 40%, 10%)")

  # Lines in map fields (yellow):
  fieldGeomYes =
    base     : pair("hsl(120, 100%, 40%)", "hsla(120, 100%, 40%, 10%)")
    selected : pair("hsl(120, 100%, 30%)", "hsla(120, 100%, 30%, 10%)")

  fieldGeomHighCertainty =
    base     : pair("hsl(300, 100%, 70%)", "hsla(300, 100%, 70%, 10%)")
    selected : pair("hsl(300, 100%, 60%)", "hsla(300, 100%, 60%, 10%)")

  fieldGeomLowCertainty =
    base     : pair("hsl(300, 100%, 40%)", "hsla(300, 100%, 40%, 40%)")
    selected : pair("hsl(300, 100%, 30%)", "hsla(300, 100%, 30%, 30%)")

  yass        = create("#5cb760")
  nope        = create("#d85553")
  unknown     = create("#777777")

  draft       = create("#00ccff")
  complete    = create("#ffcc00")
  approved    = create("#00ff00")
  review      = create("#ff2222")
  rejected    = create("#dd0000")

  red = (lightness) ->
    Color.hsl(0, 100, lightness)

  yellow = (lightness) ->
    Color.hsl(60, 100, lightness)

  green = (lightness) ->
    Color.hsl(120, 100, lightness)

  # Rescale value from the range [min, max] to the range [0, 1]:
  rescale = (value, min, max) ->
    (value - min) / (max - min)

  hue = (hue = 0) ->
    _fromFunc (fill) ->
      Color.hsl(
        hue % 360
        100
        if fill then 50 else 30
      )
      .fade(if fill then FADE_LEVEL else 0.0)
      .string()

  lookup = (num = 0, den = 10) ->
    _fromFunc (fill) ->
      Color.hsl(
        (360 * num / den + 180) % 360
        100
        40 + Math.floor(num / den) * 5 % 30 + (if fill then 30 else 0)
      )
      .fade(if fill then FADE_LEVEL else 0.0)
      .string()

  quality = (value = 0.5) ->
    _fromFunc (fill) ->
      lightness =
        if fill then 50 else 30

      base =
        if value < 0.1
          red(lightness * 0.65).mix(red(lightness), rescale(value, 0, 0.1))
        else if value < 0.5
          red(lightness).mix(yellow(lightness), rescale(value, 0.1, 0.5))
        else if value < 0.75
          yellow(lightness).mix(green(lightness), rescale(value, 0.5, 0.75))
        else
          green(lightness).mix(green(lightness * 0.5), rescale(value, 0.75, 1.0))

      base
      .fade(if fill then FADE_LEVEL else 0.0)
      .string()

  gradient = (hue, saturation, value = 0.5) ->
    _fromFunc (fill) ->
      Color.hsl(
        hue
        saturation
        if fill then 40 + 45 * value else 15 + 35 * value
      )
      .fade(if fill then FADE_LEVEL else 0.0)
      .string()

  numeric = (value0 = 0.5) ->
    value = 1.0 - value0
    gradient(240 + 60 * (value - 0.5), 40, value)

  ph = (value) ->
    lookup
    if       value < 1.0 then return create("#e4222e")
    else if  value < 2.0 then return create("#eb7831")
    else if  value < 3.0 then return create("#f19932")
    else if  value < 4.0 then return create("#f2bb33")
    else if  value < 5.0 then return create("#f7d730")
    else if  value < 6.0 then return create("#f3e934")
    else if  value < 7.0 then return create("#c9d53e")
    else if  value < 8.0 then return create("#aac556")
    else if  value < 9.0 then return create("#7daaa1")
    else if value < 10.0 then return create("#4294c2")
    else if value < 11.0 then return create("#4582c0")
    else if value < 12.0 then return create("#426fb3")
    else if value < 13.0 then return create("#5e529f")
    else                      return create("#654598")

  return {
    create
    pair

    blank

    fieldCursor
    fieldGeom
    fieldGeomYes
    fieldGeomHighCertainty
    fieldGeomLowCertainty

    yes: yass
    no: nope
    unknown

    draft
    complete
    approved
    review

    hue
    lookup
    quality
    gradient
    numeric
    ph
  }

module.exports.factory 'crtMarker', $DI (crtLog, crtLocation, crtMarkerColor) ->
  _createCoord = ([ lng, lat ]) ->
    { lng, lat }

  # geometry markerColor or(string undefined) boolean boolean -> marker
  createPath = (geom, color, label, selected = false, draggable = false) ->
    # crtLog.debug('crtMarker.createPath', { geom, color, label, selected, draggable })

    color ?= crtMarkerColor.blank

    switch geom.type
      when "Point"
        path = {
          type    : "circleMarker"
          radius  : if selected then 15 else 10
          latlngs : _createCoord(geom.coordinates)
          weight  : if selected then 3 else 1.5
        }

      when "MultiPoint"
        path = {
          type    : "polyline"
          latlngs : geom.coordinates.map(coord => [ _createCoord(coord) ])
          weight  : if selected then 5 else 2
        }

      when "LineString", "LinearRing"
        path = {
          type    : "polyline"
          latlngs : geom.coordinates.map(_createCoord)
          weight  : if selected then 5 else 2
        }

      when "MultiLineString"
        path = {
          type    : "multiPolyline"
          latlngs : geom.coordinates.map((line) -> line.map(_createCoord))
          weight  : if selected then 5 else 2
        }

      when "Polygon"
        path = {
          type    : "polygon"
          latlngs : _.flatten(geom.coordinates[0].map(_createCoord))
          weight  : if selected then 5 else 2
        }

      when "MultiPolygon"
        # TODO: Fix Multipolygon map features
        path = {
          type    : "multiPolygon"
          latlngs : geom.coordinates.map((poly) -> _.flatten(poly[0].map(_createCoord)))
          weight  : if selected then 5 else 2
        }

    if selected
      strokeColor = color.selected?.stroke ? color.stroke
      fillColor   = color.selected?.fill   ? color.fill
    else
      strokeColor = color.base?.stroke ? color.stroke
      fillColor   = color.base?.fill   ? color.fill

    _.extend(path, {
      stroke      : true
      color       : strokeColor
      opacity     : 1.0
      fillColor   : fillColor
      fillOpacity : 1.0
      draggable   : draggable
    })

    path

  return {
    createPath
  }
